import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6886457e")

_pushScopeId("data-v-6886457e")
const _hoisted_1 = { class: "formularioDatos" }
const _hoisted_2 = /*#__PURE__*/_createVNode("link", {
  rel: "stylesheet",
  href: "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,1,0"
}, null, -1)
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", { class: "text-primary" }, "Emisor", -1)
const _hoisted_7 = { class: "col-sm-8" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "razonsocial",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Razón social "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_10 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  for: "unidadNegocio",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Unidad de negocio "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_12 = {
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "bottom",
  title: "Seleccione una unidad de negocio",
  style: {"color":"#8ba7b7"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("option", {
  hidden: "",
  selected: ""
}, "Elige una opción", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h5", { class: "text-primary text-a" }, "Beneficiario", -1)
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  for: "tipopago",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Tipo pago "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_19 = { class: "col-sm-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", {
  for: "tiposolicitud",
  class: "form-label"
}, "Solicitud:", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*", -1)
const _hoisted_22 = {
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "bottom",
  title: "Tipo de Requisicion",
  style: {"color":"#8ba7b7"}
}
const _hoisted_23 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_24 = { class: "col-sm-8" }
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("label", {
  for: "razonsocial",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Nombre del beneficiario "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "col-sm-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("label", {
  for: "notificar",
  class: "form-label"
}, "Notificación de pago: ", -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", {
  for: "importe",
  class: "form-label"
}, "Importe", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*", -1)
const _hoisted_36 = { class: "input-group mb-2" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("div", { class: "input-group-text" }, "$")
], -1)
const _hoisted_38 = { class: "col-sm-6" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", {
  for: "divisa",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Divisa "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Peso Mexicano", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Dolar", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Euro", -1)
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-sm-8" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", {
  for: "importes",
  class: "form-label"
}, "Concepto de pago ", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*", -1)
const _hoisted_48 = { class: "input-group mb-2" }
const _hoisted_49 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("label", {
  for: "rfc",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" RFC "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_51 = {
  key: 1,
  class: "col-sm-4"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("label", {
  for: "rfc",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" RFC "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-sm-4" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", {
  for: "rubropresupuesto",
  class: "form-label"
}, "Rubro de presupuesto", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*", -1)
const _hoisted_57 = {
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "bottom",
  title: "Presupuesto al que pertenece el bien o servicio",
  style: {"color":"#8ba7b7"}
}
const _hoisted_58 = {
  key: 0,
  class: "form-select",
  "aria-label": "Elige una opción"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("option", { value: "99" }, "N/A", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_61 = { class: "col-sm-4" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", {
  for: "tipoGasto",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Tipo Gasto "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_63 = {
  key: 0,
  class: "form-select",
  "aria-label": "Elige una opción"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("option", { value: "1" }, "N/A", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_66 = { class: "col-sm-4" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", {
  for: "formapago",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Forma de pago "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  selected: ""
}, "Elige una opción", -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Transferencia", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Cheque simple", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Cheque certificado", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("h5", { class: "text-primary mt-4" }, "Datos de Cuenta Bancaria", -1)
const _hoisted_73 = {
  key: 0,
  class: "row"
}
const _hoisted_74 = { class: "col-12" }
const _hoisted_75 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "habilitarCuentaConClabe"
}, "Habilitar Cuenta y CLABE ", -1)
const _hoisted_76 = { class: "col-6" }
const _hoisted_77 = /*#__PURE__*/_createVNode("label", {
  for: "inputCuentaBa",
  class: "form-label"
}, "Cuenta", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("option", {
  hidden: "",
  selected: ""
}, "Elige una opción", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("option", {
  hidden: "",
  selected: ""
}, "Elige una opción", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)
const _hoisted_81 = { class: "col-6" }
const _hoisted_82 = /*#__PURE__*/_createVNode("label", {
  for: "clabe",
  class: "form-label"
}, "CLABE", -1)
const _hoisted_83 = {
  key: 0,
  id: "lblNumPosiconesCuenta"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Ingrese 18 dígitos")
const _hoisted_86 = {
  key: 1,
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" El beneficiario no cuenta con información bancaria registrada o actualizada. Favor de descargar el formato de : ")
const _hoisted_89 = /*#__PURE__*/_createVNode("strong", null, [
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Alta Proveedores ")
], -1)
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" y entregarlo a Cuentas por Pagar. ")
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-12" }
const _hoisted_93 = { class: "form-check form-switch" }
const _hoisted_94 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "habilitarConvenioreRerencia"
}, "Habilitar Convenio y Referencia", -1)
const _hoisted_95 = { class: "col-6" }
const _hoisted_96 = /*#__PURE__*/_createVNode("label", {
  for: "convenio",
  class: "form-label"
}, "No. Convenio/Servicio de pago", -1)
const _hoisted_97 = { class: "col-6" }
const _hoisted_98 = /*#__PURE__*/_createVNode("label", {
  for: "referencia",
  class: "form-label"
}, "Referencia", -1)
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-6 mt-2" }
const _hoisted_101 = /*#__PURE__*/_createVNode("label", {
  for: "banco",
  class: "form-label"
}, "Banco", -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("option", {
  value: '',
  disabled: "",
  selected: ""
}, "Selecciona un banco", -1)
const _hoisted_103 = { class: "row" }
const _hoisted_104 = {
  key: 0,
  class: "col-6 mt-2"
}
const _hoisted_105 = { class: "col" }
const _hoisted_106 = { class: "row" }
const _hoisted_107 = /*#__PURE__*/_createVNode("h5", { class: "text-primary" }, "Fechas", -1)
const _hoisted_108 = { class: "col-6" }
const _hoisted_109 = /*#__PURE__*/_createVNode("label", {
  for: "fechasolicitud",
  class: "form-label"
}, "Fecha solicitud", -1)
const _hoisted_110 = { class: "col-6" }
const _hoisted_111 = /*#__PURE__*/_createVNode("label", {
  for: "fechapropuesta",
  class: "form-label"
}, "Fecha propuesta de pago", -1)
const _hoisted_112 = {
  key: 0,
  id: "lblNumPosiconesCuenta"
}
const _hoisted_113 = {
  key: 0,
  class: "row autorizador",
  id: "autorizador"
}
const _hoisted_114 = { class: "col-md-12" }
const _hoisted_115 = /*#__PURE__*/_createVNode("h5", { class: "text-primary text-a" }, "Autorizador de área", -1)
const _hoisted_116 = /*#__PURE__*/_createVNode("label", {
  for: "fechapropuesta",
  class: "form-label"
}, null, -1)
const _hoisted_117 = { class: "input-group input-group mb-3" }
const _hoisted_118 = /*#__PURE__*/_createVNode("label", { class: "input-group-text" }, "Enviar a:", -1)
const _hoisted_119 = {
  key: 1,
  class: "row autorizador",
  id: "autorizador"
}
const _hoisted_120 = { class: "col-md-12" }
const _hoisted_121 = /*#__PURE__*/_createVNode("h5", { class: "text-primary text-a" }, "Verificador de área", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("label", {
  for: "fechapropuesta",
  class: "form-label"
}, null, -1)
const _hoisted_123 = { class: "input-group input-group mb-3" }
const _hoisted_124 = /*#__PURE__*/_createVNode("label", { class: "input-group-text" }, "Enviar a:", -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("h5", { class: "text-primary text-a" }, "Adjuntos", -1)
const _hoisted_126 = { class: "row" }
const _hoisted_127 = { class: "col-6" }
const _hoisted_128 = /*#__PURE__*/_createVNode("label", {
  for: "notificar",
  class: "form-label"
}, "No. Factura ", -1)
const _hoisted_129 = { class: "col-6" }
const _hoisted_130 = /*#__PURE__*/_createVNode("label", {
  for: "notificar",
  class: "form-label"
}, "UUID ", -1)
const _hoisted_131 = {
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "bottom",
  title: "Soporte del pago",
  style: {"color":"#8ba7b7"}
}
const _hoisted_132 = { class: "row contenedor-Documentos" }
const _hoisted_133 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-upload" })
], -1)
const _hoisted_134 = { class: "textoDrag" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" Arrastra aquí tus archivos o ")
const _hoisted_136 = { class: "custom-file" }
const _hoisted_137 = /*#__PURE__*/_createVNode("div", { class: "invalid-feedback" }, [
  /*#__PURE__*/_createVNode("h6", null, "Coloca al menos un PDF")
], -1)
const _hoisted_138 = { class: "col-md-6 area-lista-archivos" }
const _hoisted_139 = {
  key: 0,
  class: "text-center mt-5"
}
const _hoisted_140 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf iconoArchivo" }, null, -1)
const _hoisted_141 = { key: 1 }
const _hoisted_142 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf iconoArchivo" }, null, -1)
const _hoisted_143 = {
  class: "row",
  id: "observaciones"
}
const _hoisted_144 = { class: "col-md-12" }
const _hoisted_145 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Observaciones "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_146 = {
  class: "row justify-content-center",
  id: "resumenFactura"
}
const _hoisted_147 = { class: "factura-card" }
const _hoisted_148 = /*#__PURE__*/_createVNode("span", { class: "material-symbols-rounded" }, null, -1)
const _hoisted_149 = /*#__PURE__*/_createVNode("div", { class: "factura-header" }, [
  /*#__PURE__*/_createVNode("h5", null, [
    /*#__PURE__*/_createVNode("span", { class: "material-symbols-rounded icon" }, "article"),
    /*#__PURE__*/_createTextVNode(" Resumen Factura ")
  ])
], -1)
const _hoisted_150 = { class: "factura-info" }
const _hoisted_151 = /*#__PURE__*/_createVNode("span", { class: "valor" }, "+ Subtotal ", -1)
const _hoisted_152 = /*#__PURE__*/_createTextVNode()
const _hoisted_153 = { class: "valor" }
const _hoisted_154 = /*#__PURE__*/_createVNode("span", { class: "valor" }, "+ IVA", -1)
const _hoisted_155 = /*#__PURE__*/_createTextVNode()
const _hoisted_156 = { class: "valor" }
const _hoisted_157 = /*#__PURE__*/_createVNode("span", { class: "valor-retencion" }, "- Retención ISR", -1)
const _hoisted_158 = /*#__PURE__*/_createTextVNode()
const _hoisted_159 = { class: "valor-retencion" }
const _hoisted_160 = /*#__PURE__*/_createVNode("span", { class: "valor-retencion" }, "- Retención IVA", -1)
const _hoisted_161 = /*#__PURE__*/_createTextVNode()
const _hoisted_162 = { class: "valor-retencion" }
const _hoisted_163 = { class: "total-resultado" }
const _hoisted_164 = /*#__PURE__*/_createVNode("span", { class: "valor-total" }, "Total", -1)
const _hoisted_165 = /*#__PURE__*/_createTextVNode()
const _hoisted_166 = { class: "valor-total" }
const _hoisted_167 = { class: "row" }
const _hoisted_168 = /*#__PURE__*/_createVNode("div", { class: "col-sm-8" }, null, -1)
const _hoisted_169 = { class: "col-sm-12" }
const _hoisted_170 = { class: "d-flex justify-content-between" }
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { class: "fw-lighter font-monospace text-muted mt-2 mb-0" }
const _hoisted_173 = { class: "fw-lighter font-monospace text-muted" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select2 = _resolveComponent("select2")
  const _component_ModalDocumento = _resolveComponent("ModalDocumento")
  const _component_BotonPrimario = _resolveComponent("BotonPrimario")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("form", {
      id: "myform",
      method: "post",
      novalidate: "",
      ref: "formulario",
      class: { 'was-validated': _ctx.formularioValidado }
    }, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("form", {
            class: ["col", { 'was-validated': _ctx.formularioPLantillaValidado }],
            method: "post",
            novalidate: "",
            ref: "formularioPlantilla"
          }, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("span", {
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "bottom",
                  title: "Empresa emisora de pago ",
                  style: {"color":"#8ba7b7"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.requisicionPago.rfcBeneficiario = ''))
                }, [
                  _withDirectives(_createVNode("select", {
                    disabled: _ctx.esAclaracion,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.requisicionPago.empresaEmisoraId = $event)),
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ChangeRazonSocial && _ctx.ChangeRazonSocial(...args))),
                    class: "form-select",
                    "aria-label": "Elige una opción",
                    required: ""
                  }, [
                    _hoisted_9,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.EmpresasEmisoras, (empresaEmisora) => {
                      return (_openBlock(), _createBlock("option", {
                        key: empresaEmisora.nombreNav,
                        value: empresaEmisora.nombreNav
                      }, _toDisplayString(empresaEmisora.razonSocial), 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.requisicionPago.empresaEmisoraId]
                  ])
                ])
              ]),
              (_ctx.requisicionPago.empresaEmisoraId == 'Bienes Programados SA de CV')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("span", _hoisted_12, [
                      _withDirectives(_createVNode("select", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.requisicionPago.unidadNegocio = $event)),
                        class: "form-select",
                        "aria-label": "Elige una opción",
                        required: ""
                      }, [
                        _hoisted_13,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.UnidadesDeNegocio, (unidad) => {
                          return (_openBlock(), _createBlock("option", {
                            key: unidad.id,
                            value: unidad.name
                          }, _toDisplayString(unidad.name), 9, ["value"]))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.requisicionPago.unidadNegocio]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("span", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.requisicionPago.rfcBeneficiario = ''))
                }, [
                  _withDirectives(_createVNode("select", {
                    disabled: _ctx.esAclaracion,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.requisicionPago.tipoPagoId = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ChangeTipoPago && _ctx.ChangeTipoPago(...args))),
                    class: "form-select",
                    "aria-label": "Elige una opción",
                    required: ""
                  }, [
                    _hoisted_18,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.TipoPago, (tipoPago) => {
                      return (_openBlock(), _createBlock("option", {
                        key: tipoPago.tipoPagoId,
                        value: tipoPago.tipoPagoId
                      }, _toDisplayString(tipoPago.nombre), 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.requisicionPago.tipoPagoId]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _createVNode("span", _hoisted_22, [
                  _withDirectives(_createVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.requisicionPago.tipoRequisicion = $event)),
                    class: "form-select",
                    "aria-label": "Elige una opción",
                    required: ""
                  }, [
                    _hoisted_23,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.TipoRequisicion, (tipoRequisicion) => {
                      return (_openBlock(), _createBlock("option", {
                        key: tipoRequisicion.id,
                        value: tipoRequisicion.id
                      }, _toDisplayString(tipoRequisicion.name), 9, ["value"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.requisicionPago.tipoRequisicion]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                (_ctx.proveedorNAV && (_ctx.esCreacion || _ctx.esNuevaRequisicion))
                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                      _createVNode(_component_select2, {
                        class: "form-select",
                        modelValue: _ctx.requisicionPago.beneficiarioId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.requisicionPago.beneficiarioId = $event)),
                        tipo: "string",
                        disabled: _ctx.esAclaracion,
                        etiqueta: "Elige una opción Nav",
                        data: _ctx.catalogos.Proveedores.map((c) => ({ id: c.proveedorId, text: c.nombre }))
                      }, null, 8, ["modelValue", "disabled", "data"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.catalogoCuentas && (_ctx.esCreacion || _ctx.esNuevaRequisicion))
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode(_component_select2, {
                        class: "form-select",
                        modelValue: _ctx.requisicionPago.beneficiarioId,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.requisicionPago.beneficiarioId = $event)),
                        tipo: "string",
                        disabled: _ctx.esAclaracion,
                        etiqueta: "Elige una opción",
                        data: _ctx.catalogos.CatalogoCuentaBeneficiario.map((c) => ({
                      id: c.catalogoCuentaBancariaId,
                      text: c.beneficiario
                    }))
                      
                      }, null, 8, ["modelValue", "disabled", "data"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.proveedorNAV && !_ctx.catalogoCuentas)
                  ? _withDirectives((_openBlock(), _createBlock("input", {
                      key: 2,
                      type: "text",
                      class: "form-control",
                      disabled: _ctx.esAclaracion,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.requisicionPago.nombreBeneficiario = $event)),
                      required: ""
                    }, null, 8, ["disabled"])), [
                      [_vModelText, _ctx.requisicionPago.nombreBeneficiario]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_29, [
                _hoisted_30,
                _hoisted_31,
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  disabled: "",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.requisicionPago.correoBeneficiario = $event))
                }, null, 512), [
                  [_vModelText, _ctx.requisicionPago.correoBeneficiario]
                ])
              ]),
              _createVNode("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.esAclaracion,
                      type: "text",
                      pattern: "^[0-9,.$]*$",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.requisicionPago.importe = $event)),
                      maxlength: "30",
                      required: ""
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.requisicionPago.importe]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createVNode("select", {
                    disabled: _ctx.esAclaracion,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.requisicionPago.divisaId = $event)),
                    class: "form-select",
                    "aria-label": "Elige una opción",
                    required: ""
                  }, [
                    _hoisted_40,
                    _hoisted_41,
                    _hoisted_42,
                    _hoisted_43
                  ], 8, ["disabled"]), [
                    [_vModelSelect, _ctx.requisicionPago.divisaId]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode("div", _hoisted_45, [
                _hoisted_46,
                _hoisted_47,
                _createVNode("div", _hoisted_48, [
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.requisicionPago.conceptoPagos = $event)),
                    class: "form-control",
                    onKeypress: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sinCaracteresEspeciales($event))),
                    maxlength: "30",
                    required: ""
                  }, null, 544), [
                    [_vModelText, _ctx.requisicionPago.conceptoPagos]
                  ])
                ])
              ]),
              (_ctx.requisicionPago.divisaId == 2)
                ? (_openBlock(), _createBlock("div", _hoisted_49, [
                    _hoisted_50,
                    _withDirectives(_createVNode("input", {
                      class: "form-control",
                      "aria-label": "Elige una opción",
                      required: "",
                      placeholder: "Escríbe el RFC",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.requisicionPago.rfcBeneficiario = $event)),
                      maxlength: "15"
                    }, null, 512), [
                      [_vModelText, _ctx.requisicionPago.rfcBeneficiario]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.requisicionPago.divisaId == 3)
                ? (_openBlock(), _createBlock("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createVNode("input", {
                      class: "form-control",
                      "aria-label": "Elige una opción",
                      required: "",
                      placeholder: "Escríbe el RFC",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.requisicionPago.rfcBeneficiario = $event)),
                      maxlength: "15"
                    }, null, 512), [
                      [_vModelText, _ctx.requisicionPago.rfcBeneficiario]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_53, [
              _createVNode("div", _hoisted_54, [
                _hoisted_55,
                _hoisted_56,
                _createVNode("span", _hoisted_57, [
                  (_ctx.requisicionPago.tipoRequisicion == 5 )
                    ? (_openBlock(), _createBlock("select", _hoisted_58, [
                        _hoisted_59
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("select", {
                        key: 1,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.requisicionPago.tipoRubroId = $event)),
                        class: "form-select",
                        "aria-label": "Elige una opción"
                      }, [
                        _hoisted_60,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.TipoRubro, (tipoRubro) => {
                          return (_openBlock(), _createBlock("option", {
                            key: tipoRubro.tipoRubroId,
                            value: String(tipoRubro.tipoRubroId),
                            required: ""
                          }, _toDisplayString(tipoRubro.nombreRubro), 9, ["value"]))
                        }), 128))
                      ], 512)), [
                        [_vModelSelect, _ctx.requisicionPago.tipoRubroId]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_61, [
                _hoisted_62,
                (_ctx.requisicionPago.tipoRequisicion == 5 )
                  ? (_openBlock(), _createBlock("select", _hoisted_63, [
                      _hoisted_64
                    ]))
                  : _withDirectives((_openBlock(), _createBlock("select", {
                      key: 1,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.requisicionPago.tipoGastoId = $event)),
                      class: "form-select",
                      "aria-label": "Elige una opción"
                    }, [
                      _hoisted_65,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.TipoGasto, (tipoGasto) => {
                        return (_openBlock(), _createBlock("option", {
                          key: tipoGasto.tipoGastoId,
                          value: tipoGasto.tipoGastoId,
                          required: ""
                        }, _toDisplayString(tipoGasto.nombreGasto), 9, ["value"]))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.requisicionPago.tipoGastoId]
                    ])
              ]),
              _createVNode("div", _hoisted_66, [
                _hoisted_67,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.requisicionPago.formaPago = $event)),
                  class: "form-select",
                  "aria-label": "Elige una opción",
                  required: ""
                }, [
                  _hoisted_68,
                  _hoisted_69,
                  _hoisted_70,
                  _hoisted_71
                ], 512), [
                  [_vModelSelect, _ctx.requisicionPago.formaPago]
                ])
              ])
            ]),
            _hoisted_72,
            (_ctx.requisicionPago.tipoPagoId != 1041)
              ? (_openBlock(), _createBlock("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode("div", {
                      class: "form-check form-switch",
                      hidden: _ctx.esAclaracion
                    }, [
                      _hoisted_75,
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "habilitarCuentaConClabe",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.aplicaCuentaConClabe = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.aplicaCuentaConClabe]
                      ])
                    ], 8, ["hidden"])
                  ]),
                  _createVNode("div", _hoisted_76, [
                    _hoisted_77,
                    (_ctx.proveedorNAV)
                      ? _withDirectives((_openBlock(), _createBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.requisicionPago.cuentaBeneficiario = $event)),
                          class: "form-select mb-2 input-1",
                          id: "cuenta_select_nav",
                          required: _ctx.proveedorNAV && !_ctx.verFormatoAlta
                        }, [
                          _hoisted_78,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.ProveedorCuenta, (proveedorCuenta) => {
                            return (_openBlock(), _createBlock("option", {
                              key: proveedorCuenta.cuenta,
                              value: proveedorCuenta.cuenta
                            }, _toDisplayString(proveedorCuenta.nombre), 9, ["value"]))
                          }), 128))
                        ], 8, ["required"])), [
                          [_vModelSelect, _ctx.requisicionPago.cuentaBeneficiario]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.catalogoCuentas)
                      ? _withDirectives((_openBlock(), _createBlock("select", {
                          key: 1,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.requisicionPago.cuentaBeneficiario = $event)),
                          class: "form-select mb-2 input-1",
                          id: "cuenta_select_interna",
                          required: _ctx.catalogoCuentas
                        }, [
                          _hoisted_79,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.CatalogoCuentaBancaria, (cuentaBancaria) => {
                            return (_openBlock(), _createBlock("option", {
                              key: cuentaBancaria.cuenta,
                              value: cuentaBancaria.cuenta
                            }, _toDisplayString(cuentaBancaria.cuenta), 9, ["value"]))
                          }), 128))
                        ], 8, ["required"])), [
                          [_vModelSelect, _ctx.requisicionPago.cuentaBeneficiario]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", null, [
                      _createVNode("input", {
                        type: "text",
                        id: "inputCuentaBa",
                        class: "form-control",
                        placeholder: "Cuenta",
                        onInput: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
                        onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
                        value: _ctx.inpNum,
                        disabled: _ctx.requisicionPago.tipoPagoId == 1 ||
                      _ctx.requisicionPago.formaPago == 2 ||
                      _ctx.requisicionPago.formaPago == 3 ||
                      _ctx.esAclaracion
                      ,
                        maxlength: _ctx.lengthInputCuenta,
                        required: ""
                      }, null, 40, ["value", "disabled", "maxlength"]),
                      _createVNode("label", {
                        id: "lblNumPosiconesCuenta",
                        class: "mt-2",
                        hidden: _ctx.catalogoCuentas || !_ctx.verMensajeCuenta
                      }, [
                        _hoisted_80,
                        _createTextVNode(_toDisplayString(_ctx.txtPosicionesCuentaBanco), 1)
                      ], 8, ["hidden"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      maxlength: "18",
                      class: "form-control",
                      placeholder: "CLABE",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.requisicionPago.cuentaCLABE = $event)),
                      disabled: _ctx.requisicionPago.tipoPagoId == 1 ||
                    _ctx.requisicionPago.formaPago == 2 ||
                    _ctx.requisicionPago.formaPago == 3 ||
                    _ctx.esAclaracion ||
                    _ctx.requisicionPago.divisaId == 2 ||
                    _ctx.requisicionPago.divisaId == 3
                    ,
                      id: "clabe",
                      required: ""
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.requisicionPago.cuentaCLABE]
                    ]),
                    (_ctx.validanumPosicionesBanco == 2)
                      ? (_openBlock(), _createBlock("label", _hoisted_83, [
                          _hoisted_84,
                          _hoisted_85
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.verFormatoAlta)
                      ? (_openBlock(), _createBlock("div", _hoisted_86, [
                          _hoisted_87,
                          _hoisted_88,
                          _createVNode("u", {
                            "data-bs-toggle": "modal",
                            style: {"cursor":"pointer"},
                            "data-bs-target": "#modalDocumento",
                            ref: "ligaModal",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.MostrarAltaProveedor(1)))
                          }, [
                            _hoisted_89
                          ], 512),
                          _hoisted_90
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_91, [
              _createVNode("div", _hoisted_92, [
                _createVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "habilitarConvenioreRerencia",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.aplicaConvenioConReferencia = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.aplicaConvenioConReferencia]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_95, [
                _hoisted_96,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Convenio o Servicio de pago",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.requisicionPago.convenioServicioPago = $event)),
                  maxlength: "20",
                  id: "convenio",
                  ref: "convenioservicio",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.requisicionPago.convenioServicioPago]
                ])
              ]),
              _createVNode("div", _hoisted_97, [
                _hoisted_98,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Escríbe tu referencia bancaria",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.requisicionPago.referencia = $event)),
                  maxlength: _ctx.referenciaMaxlength,
                  id: "referencia",
                  ref: "referencia",
                  required: ""
                }, null, 8, ["maxlength"]), [
                  [_vModelText, _ctx.requisicionPago.referencia]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_99, [
              _createVNode("div", _hoisted_100, [
                _hoisted_101,
                _withDirectives(_createVNode("select", {
                  class: "form-select",
                  name: "bancoSelect",
                  id: "bancoSelect",
                  ref: "bancoSelect",
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.requisicionPago.bancoBeneficiario = $event)),
                  required: ""
                }, [
                  _hoisted_102,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Bancos, (banco) => {
                    return (_openBlock(), _createBlock("option", {
                      key: banco.clave
                    }, _toDisplayString(banco.nombre), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.requisicionPago.bancoBeneficiario]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_103, [
              (_ctx.catalogoCuentas)
                ? (_openBlock(), _createBlock("div", _hoisted_104, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      placeholder: "Banco TXT",
                      name: "",
                      class: "form-control",
                      id: "banco_txt",
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.requisicionPago.bancoBeneficiario = $event)),
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.requisicionPago.bancoBeneficiario]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createVNode("div", _hoisted_105, [
            _createVNode("div", _hoisted_106, [
              _hoisted_107,
              _createVNode("div", _hoisted_108, [
                _hoisted_109,
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control",
                  id: "fechasolicitud",
                  disabled: "",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.requisicionPago.fechaSolicitud = $event))
                }, null, 512), [
                  [_vModelText, _ctx.requisicionPago.fechaSolicitud]
                ])
              ]),
              _createVNode("div", _hoisted_110, [
                _hoisted_111,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.requisicionPago.fechaProgramadaPago = $event)),
                  onInput: _cache[36] || (_cache[36] = ($event: any) => (_ctx.ValidarFecha($event.target.value))),
                  type: "date",
                  class: "form-control",
                  id: "fechapropuesta",
                  min: _ctx.FechaMinima(),
                  max: _ctx.FechaMaxima(),
                  required: ""
                }, null, 40, ["min", "max"]), [
                  [_vModelText, _ctx.requisicionPago.fechaProgramadaPago]
                ]),
                (_ctx.diaHabil)
                  ? (_openBlock(), _createBlock("small", _hoisted_112, "Día inhábil"))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.tieneVerificador)
              ? (_openBlock(), _createBlock("div", _hoisted_113, [
                  _createVNode("div", _hoisted_114, [
                    _createVNode("div", null, [
                      _hoisted_115,
                      _hoisted_116,
                      _createVNode("div", _hoisted_117, [
                        _hoisted_118,
                        _withDirectives(_createVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.requisicionPago.usuarioAutorizadorId = $event)),
                          required: ""
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Autorizadores, (autorizador) => {
                            return (_openBlock(), _createBlock("option", {
                              key: autorizador.id,
                              value: autorizador.id
                            }, _toDisplayString(autorizador.normalizedUserName), 9, ["value"]))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.requisicionPago.usuarioAutorizadorId]
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tieneVerificador)
              ? (_openBlock(), _createBlock("div", _hoisted_119, [
                  _createVNode("div", _hoisted_120, [
                    _createVNode("div", null, [
                      _hoisted_121,
                      _hoisted_122,
                      _createVNode("div", _hoisted_123, [
                        _hoisted_124,
                        _withDirectives(_createVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.requisicionPago.usuarioVerificadorAreaId = $event)),
                          required: ""
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Autorizadores, (autorizador) => {
                            return (_openBlock(), _createBlock("option", {
                              key: autorizador.id,
                              value: autorizador.id
                            }, _toDisplayString(autorizador.normalizedUserName), 9, ["value"]))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.requisicionPago.usuarioVerificadorAreaId]
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_125,
            _createVNode("div", _hoisted_126, [
              _createVNode("div", _hoisted_127, [
                _hoisted_128,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.requisicionPago.numeroFactura = $event)),
                  maxlength: "20"
                }, null, 512), [
                  [_vModelText, _ctx.requisicionPago.numeroFactura]
                ])
              ]),
              _createVNode("div", _hoisted_129, [
                _hoisted_130,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.requisicionPago.uuid = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.requisicionPago.uuid]
                ])
              ])
            ]),
            _createVNode("span", _hoisted_131, [
              _createVNode("div", _hoisted_132, [
                _createVNode("div", {
                  class: "col-md-6 area-drag",
                  onDragover: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.DragArchivo && _ctx.DragArchivo(...args))),
                  onDrop: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.DropArchivo && _ctx.DropArchivo(...args)))
                }, [
                  _hoisted_133,
                  _createVNode("span", _hoisted_134, [
                    _hoisted_135,
                    _createVNode("span", {
                      class: "buscarDrag",
                      onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.ClickAInput && _ctx.ClickAInput(...args)))
                    }, "Busca aquí tus archivos")
                  ]),
                  _createVNode("div", _hoisted_136, [
                    _withDirectives(_createVNode("input", {
                      ref: "inputArchivo",
                      type: "file",
                      multiple: "",
                      onChange: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.SubirArchivo && _ctx.SubirArchivo(...args))),
                      onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.LimpiarInputFile && _ctx.LimpiarInputFile(...args))),
                      class: "custom-file-input form form-control",
                      id: "validatedCustomFile",
                      accept: "application/pdf, text/xml",
                      required: _ctx.documentosExistentes.length == 0 && _ctx.archivosRequisicion.length == 0
                    }, null, 40, ["required"]), [
                      [_vShow, false]
                    ]),
                    _hoisted_137
                  ])
                ], 32),
                _createVNode("div", _hoisted_138, [
                  (_ctx.archivosRequisicion == 0 && _ctx.documentosExistentes == 0)
                    ? (_openBlock(), _createBlock("p", _hoisted_139, " Aquí se mostraran los archivos que cargues. "))
                    : _createCommentVNode("", true),
                  _createVNode("ul", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.archivosRequisicion, (archivo) => {
                      return (_openBlock(), _createBlock("li", {
                        class: "archivoSubido",
                        key: archivo.lastModified
                      }, [
                        _hoisted_140,
                        _createTextVNode(_toDisplayString(archivo.name) + " ", 1),
                        _createVNode("i", {
                          class: "fas fa-times iconoEliminarArchivo",
                          onClick: _withModifiers(($event: any) => (_ctx.EliminarArchivo(archivo.name)), ["prevent"])
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.requisicionIdExistente != null)
                    ? (_openBlock(), _createBlock("ul", _hoisted_141, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentosExistentes, (documento) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "archivoSubido",
                            key: documento.documentoRequisicionPagoId
                          }, [
                            _hoisted_142,
                            (documento.tipoDocumento == 'PDF')
                              ? (_openBlock(), _createBlock("u", {
                                  key: 0,
                                  style: {"cursor":"pointer"},
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#modalDocumento",
                                  ref: "ligaModal",
                                  onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.tipoDocumento))
                                }, _toDisplayString(documento.fechaSubida.substring(0, 10).toLowerCase()), 9, ["onClick"]))
                              : _createCommentVNode("", true),
                            (documento.tipoDocumento != 'PDF')
                              ? (_openBlock(), _createBlock("u", {
                                  key: 1,
                                  "data-bs-toggle": "modal",
                                  style: {"cursor":"pointer"},
                                  "data-bs-target": "",
                                  ref: "ligaModal",
                                  onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.tipoDocumento))
                                }, _toDisplayString(documento.fechaSubida.substring(0, 10).toLowerCase()), 9, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode("i", {
                              class: "fas fa-times iconoEliminarArchivo",
                              onClick: _withModifiers(($event: any) => (_ctx.EliminarArchivoExistente(documento.documentoRequisicionPagoId)), ["prevent"])
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_ModalDocumento, {
                  documentoId: _ctx.documentoId,
                  rutaDocumento: _ctx.rutaDocumentoExistente
                }, null, 8, ["documentoId", "rutaDocumento"])
              ])
            ]),
            _createVNode("div", _hoisted_143, [
              _createVNode("div", _hoisted_144, [
                _hoisted_145,
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.requisicionPago.observacionPago = $event)),
                  class: "form-control",
                  placeholder: "Escríbe aqui tus observaciones",
                  rows: "1",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.requisicionPago.observacionPago]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_146, [
              _createVNode("div", _hoisted_147, [
                _hoisted_148,
                _hoisted_149,
                _createVNode("ul", _hoisted_150, [
                  _createVNode("li", null, [
                    _hoisted_151,
                    _hoisted_152,
                    _createVNode("span", _hoisted_153, _toDisplayString(Number(_ctx.requisicionPago.datosFactura.subtotal).toLocaleString('es-MX', {
                      style: 'currency',
                      currency: 'MXN'
                    })), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_154,
                    _hoisted_155,
                    _createVNode("span", _hoisted_156, _toDisplayString(Number(_ctx.requisicionPago.datosFactura.iva).toLocaleString('es-MX', {
                      style: 'currency', currency:
                        'MXN'
                    })), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_157,
                    _hoisted_158,
                    _createVNode("span", _hoisted_159, _toDisplayString(Number(_ctx.requisicionPago.datosFactura.retencionISR).toLocaleString('es-MX', {
                      style: 'currency',
                      currency: 'MXN'
                    })), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_160,
                    _hoisted_161,
                    _createVNode("span", _hoisted_162, _toDisplayString(Number(_ctx.requisicionPago.datosFactura.retencionIVA).toLocaleString('es-MX', {
                      style: 'currency',
                      currency: 'MXN'
                    })), 1)
                  ]),
                  _createVNode("li", _hoisted_163, [
                    _hoisted_164,
                    _hoisted_165,
                    _createVNode("span", _hoisted_166, _toDisplayString(Number(_ctx.requisicionPago.datosFactura.total).toLocaleString('es-MX', {
                      style: 'currency', currency:
                        'MXN'
                    })), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_167, [
          _hoisted_168,
          _createVNode("div", _hoisted_169, [
            _createVNode("div", _hoisted_170, [
              _createVNode(_component_BotonPrimario, {
                onClick: _cache[47] || (_cache[47] = _withModifiers(($event: any) => (_ctx.ActualizarRequisicion()), ["prevent"])),
                cargando: _ctx.estaCargandoActualizar,
                icono: "fas fa-chevron-right",
                color: "btn-outline-primary",
                texto: "Actualizar",
                mensaje: "Actualizando",
                id: "btn-actualizar",
                hidden: _ctx.esNuevaRequisicion
              }, null, 8, ["cargando", "hidden"]),
              _createVNode("div", null, [
                _createVNode(_component_BotonPrimario, {
                  onClick: _cache[48] || (_cache[48] = _withModifiers(($event: any) => (_ctx.GuardarRequisicion()), ["prevent"])),
                  cargando: _ctx.estaCargandoGuardar,
                  hidden: !_ctx.esNuevaRequisicion,
                  icono: "fas fa-save",
                  color: "btn-outline-primary",
                  texto: "Guardar",
                  mensaje: "Guardando"
                }, null, 8, ["cargando", "hidden"]),
                _createVNode(_component_BotonPrimario, {
                  onClick: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.GuardarActualizarPlantilla()), ["prevent"])),
                  cargando: false,
                  icono: "fas fa-bookmark",
                  color: "btn-outline-accent",
                  texto: _ctx.actulizarPlantilla ? 'Actualizar Plantilla' : 'Guardar Plantilla',
                  class: "mx-2",
                  mensaje: "Guardando plantilla"
                }, null, 8, ["texto"])
              ]),
              (_ctx.esAclaracion)
                ? (_openBlock(), _createBlock(_component_BotonPrimario, {
                    key: 0,
                    onClick: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.ReenviarRequisicion()), ["prevent"])),
                    cargando: _ctx.estaCargandoReenviar,
                    icono: "fas fa-save",
                    color: "btn-primary text-white",
                    texto: "Actualizar y reenviar",
                    mensaje: "Enviando"
                  }, null, 8, ["cargando"]))
                : (_ctx.esNuevaRequisicion || _ctx.esCreacion)
                  ? (_openBlock(), _createBlock(_component_BotonPrimario, {
                      key: 1,
                      onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.EnviarRequisicion()), ["prevent"])),
                      cargando: _ctx.estaCargandoEnviar,
                      icono: "fas fa-chevron-right",
                      color: "btn-primary text-white",
                      texto: "Enviar",
                      mensaje: "Enviando"
                    }, null, 8, ["cargando"]))
                  : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 2),
    (_ctx.$props.plantilla)
      ? (_openBlock(), _createBlock("div", _hoisted_171, [
          _createVNode("p", _hoisted_172, "Última actualización : " + _toDisplayString(_ctx.$props.plantilla.fechaUltimaModificacion.slice(0, 19)), 1),
          _createVNode("p", _hoisted_173, "Responsable : " + _toDisplayString(_ctx.$props.plantilla.nombreUsuario), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})